import gql from 'graphql-tag';

export const CreateSmartLinkEmbedMutation = gql`
	mutation CreateSmartLinkEmbedMutation(
		$contentSpecificCreateInput: [ContentSpecificCreateInput!]
		$parentId: ID
		$spaceKey: String
		$title: String
		$type: String!
		$status: GraphQLContentStatus!
	) {
		createContentContextual(
			input: {
				contentSpecificCreateInput: $contentSpecificCreateInput
				parentId: $parentId
				spaceKey: $spaceKey
				title: $title
				type: $type
				status: $status
			}
		) {
			id
			space {
				id
				key
				alias
			}
		}
	}
`;
